export default "__VITE_ASSET__B0Kn93bT__"